(() => {
  angular.module('pims').directive('visitRefills', () => {
    return {
      restrict: 'E',
      scope: {
        parent: '=',
        patient: '=',
        tab: '=',
        visit: '=',
        isActiveTab: '=', },
      template: '<refills [visit]="visit"> Visit refills</refills>'
    };
  });
})();
